import React from 'react'
import { useThemeMediaQuery } from 'hooks/useThemeMediaQuery'
import { CheckIcon, Flex, Text, TextVariant } from '@mprolab/uikit'
import styled, { useTheme } from 'styled-components'
import { Clock } from 'react-feather'

import { useTranslation } from 'react-i18next'

const ContentBox = styled(Flex)`
  padding: 64px 80px;
  background: ${({ theme }) => theme.colors.backgroundContrast};
  ${({ theme }) => theme.mediaQueries.tablet} {
    padding: 32px 40px;
  }
  ${({ theme }) => theme.mediaQueries.mobile} {
    padding: 32px 24px;
  }
`

const IconWrapper = styled(Flex)<{ active?: boolean }>`
  width: 48px;
  height: 48px;
  padding: 16px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.gray10};
  border: 1px solid ${({ theme, active }) => (active ? theme.colors.yellow : theme.colors.gray6)};
  z-index: 2;
`

const ConnectorLine = styled(Flex)`
  width: 2px;
  height: 90px;
  border-left: 1px dashed ${({ theme }) => theme.colors.gray7};
  position: absolute;
  left: 23px;
  top: 54px;
`

const ComingSoonNodesPlaceholder: React.FC = () => {
  const { t } = useTranslation()
  const { colors } = useTheme()
  const isMobile = useThemeMediaQuery('mobile')

  return (
    <Flex
      flexDirection="column"
      justifyContent={isMobile ? 'initial' : 'space-between'}
      height="100%"
      maxWidth={966}
      gap={isMobile ? '32px' : '0'}
    >
      <ContentBox>
        <Flex flexDirection="column" gap="56px" position="relative">
          <Flex gap={isMobile ? '16px' : '64px'}>
            <IconWrapper>
              <CheckIcon color={colors.white} />
            </IconWrapper>
            <Flex flexDirection="column" gap="16px" maxWidth="222px">
              <Text color={colors.gray6} variant={TextVariant.BODY_DEFAULT_BOLD}>
                {t('nodesPlaceholder.phase1')}
              </Text>
              <Text color={colors.gray6}>{t('nodesPlaceholder.soldPhase1')}</Text>
            </Flex>
          </Flex>
          <Flex gap={isMobile ? '16px' : '64px'}>
            <IconWrapper active>
              <Clock color={colors.white} />
            </IconWrapper>
            <Flex flexDirection="column" gap="16px" maxWidth="436px">
              <Text variant={TextVariant.H4}>{t('nodesPlaceholder.phase2')}</Text>
              <Text color={colors.yellow}>{t('nodesPlaceholder.soldPhase2')}</Text>
            </Flex>
          </Flex>
          <Flex gap={isMobile ? '16px' : '64px'}>
            <Flex width="48px" />
            <Flex flexDirection="column" gap="16px">
              <Text>
                <u>{t('nodesPlaceholder.secureMpro')}</u> {t('nodesPlaceholder.toBuyNode')}
              </Text>
              <Text variant={TextVariant.BODY_SMALL} color={colors.gray6}>
                {t('nodesPlaceholder.tge')}
              </Text>
            </Flex>
          </Flex>
          <ConnectorLine />
        </Flex>
      </ContentBox>
      <Text textAlign="center" color={colors.gray3}>
        <b>{t('nodesPlaceholder.nodes')}</b> {t('nodesPlaceholder.nodesDescription')}
      </Text>
    </Flex>
  )
}

export default ComingSoonNodesPlaceholder
